import { render, staticRenderFns } from "./MailAdd.vue?vue&type=template&id=1461b27c&scoped=true&"
import script from "./MailAdd.vue?vue&type=script&lang=js&"
export * from "./MailAdd.vue?vue&type=script&lang=js&"
import style0 from "./MailAdd.vue?vue&type=style&index=0&id=1461b27c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461b27c",
  null
  
)

export default component.exports